import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import ModelManagement from './components/ModelManagement';
import Guardrails from './components/Guardrails';
import UserManagement from './components/UserManagement';
import PromptMonitoring from './components/PromptMonitoring';
import GpuOverview from './components/GpuOverview';
import ChatConsole from './components/ChatConsole';
import Login from './components/Login';
export function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  // Check if user is already authenticated on load
  useEffect(() => {
    const authStatus = localStorage.getItem('membrain_authenticated');
    setIsAuthenticated(authStatus === 'true');
    setIsLoading(false);
  }, []);
  const handleLogin = (username, password) => {
    // Only allow specific credentials: username "admin" and password "Amoebix@2088"
    if (username === 'admin' && password === 'Amoebix@2088') {
      localStorage.setItem('membrain_authenticated', 'true');
      setIsAuthenticated(true);
      return true;
    }
    return false;
  };
  const handleLogout = () => {
    localStorage.removeItem('membrain_authenticated');
    setIsAuthenticated(false);
  };
  if (isLoading) {
    return <div className="w-full min-h-screen bg-gray-50 flex items-center justify-center" data-id="element-0">
        Loading...
      </div>;
  }
  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} data-id="element-1" />;
  }
  return <Router data-id="element-2">
      <div className="w-full min-h-screen bg-gray-50" data-id="element-3">
        <Layout onLogout={handleLogout} data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<Dashboard data-id="element-7" />} data-id="element-6" />
            <Route path="/chat" element={<ChatConsole data-id="element-9" />} data-id="element-8" />
            <Route path="/models" element={<ModelManagement data-id="element-11" />} data-id="element-10" />
            <Route path="/guardrails" element={<Guardrails data-id="element-13" />} data-id="element-12" />
            <Route path="/users" element={<UserManagement data-id="element-15" />} data-id="element-14" />
            <Route path="/prompts" element={<PromptMonitoring data-id="element-17" />} data-id="element-16" />
            <Route path="/gpu" element={<GpuOverview data-id="element-19" />} data-id="element-18" />
            <Route path="*" element={<Navigate to="/" replace data-id="element-21" />} data-id="element-20" />
          </Routes>
        </Layout>
      </div>
    </Router>;
}